<template>
  <div class="app-filters">
    <template v-if="data && data.filters">
      <transition name="slide-right" appear>
        <div v-show="visible" class="app-filters-content flex-column">
          <div class="app-filters-header modal-header d-flex align-items-center">
            <h2 class="modal-title">Фильтры</h2>
            <span>Найдено {{ data.total }}</span>
            <button class="btn btn-outline-primary btn-sm" @click="reset">Сбросить</button>
          </div>
          <div class="modal-body app-filters-scroll" ref="scrollContainer">
            <div class="app-filters-body modal-body">
              <filters
                :filters="data.filters"
                :endpoint="endpoint"
                v-model="values"
                ref="filters"
              />
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade" appear>
        <div v-show="visible" class="app-filters-backdrop" @click="hide"></div>
      </transition>
    </template>
  </div>
</template>

<script>
  import $ from 'jquery'

  export default {
    name: 'AppFilters',
    props: {
      value: {},
      data: {},
      endpoint: {},
    },
    data () {
      return {
        visible: false,
        resolve: null,
        values: this.value,
      }
    },
    watch: {
      value () {
        this.values = this.value
      },
      values: {
        deep: true,
        handler (values) {
          this.$emit('input', values)
        },
      },
    },
    methods: {
      reset () {
        this.values = {}
        this.$refs.filters.collapseAll()
        $(this.$refs.scrollContainer).animate({scrollTop: 0}, 300)
      },
      show () {
        return new Promise((resolve) => {
          this.visible = true
          this.resolve = resolve
        })
      },
      hide (value) {
        this.visible = false
        this.resolve(value)
        this.resolve = null
      },
      apply () {
        this.hide()
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  $filters-width: 26rem;
  $app-filters-header-height: 3rem;
  .app-filters {}
  .app-filters-content {
    display: flex;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: $filters-width;
    z-index: $zindex-modal + 2;
    background-color: #fff;
    border-radius: 0;
    border-width: 0;
    @include box-shadow(-5px 0 15px rgba(#000, .25));
  }
  .app-filters-header {
    position: absolute;
    z-index: $zindex-popover + 5;
    top: 0;
    left: 0;
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
    display: block;
    background-color: rgba($modal-header-border-color, .75);
    backdrop-filter: saturate(180%) blur(2px);
    border-bottom: 0;
    > .modal-title {
      line-height: $app-filters-header-height;
    }
  }
  .app-filters-scroll {
    overflow-y: scroll;
    overflow-x: hidden;
    margin: 0 -30px 0 0;
    padding: $app-filters-header-height 20px 0 0;
  }
  .app-filters-body {
    padding-left: 0;
  }
  .app-filters-footer {
    display: block;
    border-bottom: 1px solid rgba(#000, .3);
    background-clip: padding-box;
    box-shadow: 0 0 5px rgba(#000, .2);
  }
  .app-filters-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: $zindex-modal + 1;
    background-color: rgba($modal-backdrop-bg, $modal-backdrop-opacity);
  }

  //.filter-bucket-size {
  //  float: right;
  //}

  // Transition
  .slide-right-enter-active, .slide-right-leave-active {
    transition: .35s ease-out;
    transition-timing-function: cubic-bezier(.61,.67,.02,.99);
    transition-property: transform, box-shadow;
  }
  .slide-right-leave-active {
    transition-duration: .1s !important;
    transition-timing-function: linear !important;
  }
  .slide-right-enter, .slide-right-leave-to {
    transform: translate($filters-width, 0);
    @include box-shadow(0 0 0 rgba(#000, 0));
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/app-filters.vue